// API Configuration
const apiConfig = {
  baseUrl: '/payrollBackend',
  timeout: 30000,
  version: 'v1',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

export default apiConfig;
